<template>
  <UModal
    title="Выберите город"
    closable
    :class="ui?.root"
    :ui="{
      header: 'border-0',
      title: 'text-3xl font-semibold',
      body: 'pt-3!',
      overlay: 'bg-overlay',
    }"
  >
    <template #close>
      <UButton
        class="ml-auto"
        variant="outline"
        icon="i-local-close"
        color="neutral"
        size="sm"
      />
    </template>

    <template #body>
      <UInput
        v-model="query"
        class="mb-3 w-full"
        :class="ui?.searchInput"
        icon="i-local-search"
        placeholder="Ваш город"
      />
      <UListbox
        :model-value="selectedCity ?? undefined"
        class="rounded-none ring-0"
        :class="ui?.cityList"
        :items="filteredCities"
        :ui="{
          item: 'data-[state=checked]:text-accent-default data-[state=checked]:bg-accent-container-light rounded',
          itemTrailingIcon: 'text-accent-default',
        }"
        @update:model-value="selectedCity = $event as any"
      />
    </template>
  </UModal>
</template>

<script setup lang="ts">
defineOptions({
  name: 'SPCitySelectModal',
})

const directoryStore = useDirectoryStore()
const { cities, selectedCity } = storeToRefs(directoryStore)

defineProps<{
  ui?: {
    root?: string
    searchInput?: string
    cityList?: string
  }
}>()

const query = ref('')

const filteredCities = computed(() => {
  if (!query.value) return cities.value

  return cities.value.filter((city) =>
    city.label.toLowerCase().includes(query.value.toLowerCase()),
  )
})
</script>
